// Implements: F-UIX-025
/**
 * Deployment-level switches, read from the build environment the way Vite exposes it.
 *
 * `VITE_DEMO_AUTO_APPROVE` (owner decision OD-12) turns off the confirmation that
 * stands in front of an expensive action, so a demo is not interrupted by it. It is a
 * property of the deployment, never of the person: there is no screen that sets it.
 * Only the exact word `true` turns it on; anything else, or nothing, leaves the
 * confirmations as they are. It is read at call time, not at import, so a test can
 * stub the environment.
 */

export function demoAutoApprove(): boolean {
  return import.meta.env.VITE_DEMO_AUTO_APPROVE === "true";
}
